import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "AutoCAD Fundamentals & Design Environment",
    description:
      "Introduction to CAD, drafting & design principles, AutoCAD interface workspace & toolbar navigation, Understanding units limits grid & drafting standards, Setting up drawing templates for professional work",
  },
  {
    title: "Basic Drawing Tools & 2D Geometry Creation",
    description:
      "Creating basic shapes: lines, circles, arcs, polygons, Precision commands: ORTHO, OSNAP, OTRACK, Modifying tools: move, copy, trim, extend, offset, Practicing 2D sketches with real-world examples",
  },
  {
    title: "Advanced Modelling & Editing Commands",
    description:
      "Fillet, chamfer, array, mirror, scale & rotate, Construction lines & advanced snapping, Creating complex shapes using Polyline & Spline, Dynamic blocks & block attribute creation",
  },
  {
    title: "Layers, Properties & Object Management",
    description:
      "Layer creation & layer management, Color linetype & lineweight control, Grouping naming & managing drawing objects, Organizing large drawings using layers effectively",
  },
  {
    title: "Annotations, Dimensions & Text Tools",
    description:
      "Creating dimension styles, Linear aligned radial & angular dimensions, Adding text leaders & tables, Maintaining drawing clarity through proper annotation",
  },
  {
    title: "Hatch Patterns, Gradients & Object Styling",
    description:
      "Using hatch patterns for sections & areas, Boundary detection & editing hatch properties, Gradient fills & solid fills, Enhancing drawings with professional styling techniques",
  },
  {
    title: "Layouts, Viewports & Plotting Techniques",
    description:
      "Model space vs paper space, Creating viewports & adjusting scales, Title blocks creation & insertion, Printing & plotting with correct scaling & quality",
  },
  {
    title: "Introduction to 3D Modelling in AutoCAD",
    description:
      "Understanding 3D coordinate systems, Extrude revolve sweep & loft, 3D primitives & solid modelling, Viewing orbiting & visual styles for 3D",
  },
  {
    title: "Rendering, Materials & Presentation Skills",
    description:
      "Applying materials & textures, Lighting & shadows for realistic output, Rendering settings & exporting images, Preparing designs for client presentations",
  },
  {
    title: "Capstone CAD Project & Professional Workflow",
    description:
      "Creating a complete 2D + 3D project, Floor plan elevation & sectional drawing, Converting sketches into production-level drafts, Portfolio creation for job roles in CAD drafting & design, Interview preparation for AutoCAD Designer / Draughtsman roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
